
  import { defineComponent } from 'vue';
  import GrouperTitle from 'components/grouper-common/GrouperTitle.vue';
  import GrouperHeader from 'components/grouper-common/GrouperHeader.vue';
  import GrouperInfo from 'components/grouper-common/GrouperInfo.vue';
  import GrouperFooter from 'components/grouper-common/GrouperFooter.vue';
  import GrouperBody from 'components/grouper-common/GrouperBody.vue';
  export default defineComponent({
    name: 'MainLayout',

    components: {
      GrouperHeader,
      GrouperTitle,
      GrouperInfo,
      GrouperFooter,
      GrouperBody
    },
  });
